'use strict';

// Dependencies
const Backbone = require('dibs-backbone');
const HasMany = Backbone.Many;
const DataListModel = require('bunsen/models/DataListModel');
const Photo = require('bunsen/models/inventory/Photo');
const endpoints = require('dibs-endpoints');
const assert = require('bunsen/helpers/assert');
const PHOTOS_API_TYPE = "photos";
let PhotosDataList;

const _DataListModel = DataListModel.extend({
    relations : [
        {
            type: HasMany,
            key: 'dataList',
            relatedModel: Photo
        }
    ]
});

/**
 * @class PhotosDataList
 * @extends SolrSearchModel
 */
PhotosDataList = module.exports = _DataListModel.extend({

    initialize(attributes) {
        // we only need to set the dataList from the DataListModel, enforce that the apiType be "photos"
        return PhotosDataList.__super__.initialize.call(this, {
            dataList : attributes.dataList,
            apiType : PHOTOS_API_TYPE
        });
    },

    url() {
        return endpoints.photos(this.itemId);
    },

    setItemId(itemId) {
        this.itemId = itemId;
    },

    save(attributes, options) {
        assert(this.itemId, 'You must set an itemId for these photos in order to save.');
        return PhotosDataList.__super__.save.call(this, attributes, options);
    },

    /**
     * Remove photo models that do not have any versions. These are sometimes duds created by the image upload page
     * or they could just be photos with bad data that we do not want to save.
     */
    removeInvalidPhotos() {
        const duds = this.get('dataList').filter(photo => {
            return !photo.get('versions') || !photo.get('versions').length;
        });
        if (duds.length) {
            this.get('dataList').remove(duds);
        }
    }
});



// WEBPACK FOOTER //
// ./~/bunsen/models/inventory/PhotosDataList.es.js